export default __webpack_public_path__ + "static/media/homei2.119b7ad8.png";